'use client'

import React, { ReactNode, RefObject, useEffect, useRef, useState } from 'react'
import { useInView } from 'motion/react'

interface IAnimatedElement {
    children?: ReactNode
    className?: string | undefined
    delay?: number | undefined
    element?: string | undefined
    dangerouslySetInnerHTML?: { __html: string | undefined } | null | undefined
    style?: React.CSSProperties
}

export const AnimatedElement = ({
    children,
    className = '',
    delay = 0,
    element = 'div',
    dangerouslySetInnerHTML = null,
    style = {},
}: IAnimatedElement) => {
    const ref: RefObject<Element | null> = useRef(null)

    const [visible, setVisible] = useState(false)

    const isInView = useInView(ref, {
        once: true,
    })

    useEffect(() => {
        setTimeout(() => {
            if (isInView) {
                setVisible(true)
            }
        }, 100)
    }, [isInView])

    return React.createElement(element, {
        className: `${className} AnimateDiv ${visible ? 'Visible' : ''}`,
        ref,
        style: {
            ...style,
            transitionDelay: delay ? `${delay + 0.2}s` : '0s',
        },
        ...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : { children }),
    })
}
